import { render, staticRenderFns } from "./FormVersions.vue?vue&type=template&id=b144cf2a&"
import script from "./FormVersions.vue?vue&type=script&lang=js&"
export * from "./FormVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports